import customHeaders, { getSpace } from '../../common/headers';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { useState, useRef, useEffect } from 'react';
import {
  DropDownSelector,
  SearchComponent,
  Tabs,
  TableBox,
} from '@lk-gtcom/ecomlab-components';
import {
  fetchMPApiFilter,
  fetchMPCategoryFilter,
  fetchMPBrandFilter,
} from '../../common/filtersFunc';
import { KonstantinMasterHttps } from '../../fetchUrls';
import useGeneralStore from '../../store/general';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { periodWeek } from '../../common/constant';
import { useResponseHandler } from '../../common/auth';
import './InstallationDRR.scss';

const InstallationDRR = ({
  refContainer,
  stopRedirect = false,
  isShowTitle = true,
  selectedApiModal,
  selectedMpModal,
  page = true
}) => {

  const btn_tab = [
    ...(page ? [ { label: 'Все', value: 'all' }] : []),
    { label: 'Участвуют', value: 'participate' },
    { label: 'Не участвуют', value: 'not_participate' }
  ]

  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);
  const [searchValue, setSearchValue] = useState('');
  const [searchData, setSearchData] = useState([]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0)

  const [date, setDate] = useState(periodWeek());
  const [dateFrom, dateTo] = date;

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;
  const [isClear, setIsClear] = useState(false);
  const [pageValue, setPageValue] = useState(btn_tab[0]?.value)

  const fetchTableData = (params, abortController = new AbortController()) => {
    let sort;
    let filtersParam;

    if (params) {
      [sort, filtersParam] = params;
    }

    setLoading(true);

    let url = `https://apps0.ecomru.ru:4449/mp-products/tables/drr-table${sort?.length > 0
      ? '?order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`

    let api_id_list;
    let brand_id_list;
    let category_id_list;
    let offer_id_name_search = searchValue;

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el?.value);
    }

    if (selectedApiModal?.value) {
      api_id_list = selectedApiModal?.value ? [selectedApiModal?.value] : ['all'];
    }

    const body = JSON.stringify({
      mp_id_list: page ? ["all"] : (selectedMpModal?.value ? [selectedMpModal?.value] : ["all"]),
      offer_id_list: ["all"],
      category_id_list,
      brand_id_list,
      api_id_list,
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
      filters: filtersParam,
      offer_id_name_search,
      status: "Все",
      participate_status: pageValue === 'all' ? null : pageValue
    })

    fetch(url, {
      body,
      method: 'POST',
      headers,
      signal: abortController.signal,
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => setTable(json))
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (!abortController.signal.aborted) {
          setLoading(false);
        }
      });
  };

  const fetchSearch = (
    [search, page = 1],
    abortController = new AbortController()
  ) => {
    let url = `${KonstantinMasterHttps}/mp-products/filters/offer-id-name`;

    let api_id_list;
    let brand_id_list;
    let category_id_list;

    if (selectedApi?.length > 0) {
      api_id_list = selectedApi?.map((el) => el.value);
    }

    if (selectedBrand?.length > 0) {
      brand_id_list = selectedBrand?.map((el) => el.value);
    }

    if (selectedCategory?.length > 0) {
      category_id_list = selectedCategory?.map((el) => el.value);
    }

    if (selectedApiModal?.value) {
      api_id_list = selectedApiModal?.value ? [selectedApiModal?.value] : ['all'];
    }

    const body = JSON.stringify({
      api_id_list,
      category_id_list,
      brand_id_list,
      page: page,
      limit: 10,
      search_param: search,
    });

    fetch(url, { body, method: 'POST', headers, signal: abortController.signal})
      .then(handleTableResponse)
      .then((json) => {
        let result = [];
        if (json) {
          result = json?.map(({ id, name, image }, ind) => {
            return { label: name, value: id, image: image };
          });
        }
        setSearchData(result);
      })
      .catch(handleRequestError);
  };

  const filtersApi = () => {
    fetchMPApiFilter({
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalApi,
      page: apiPage,
      setApiData: (e) => setApiData(e),
      searchParam: apiQuery,
      withAll: false,
    });
  };

  const filtersCategory = () => {
    fetchMPCategoryFilter({
      selectedSpace: selectedSpace?.value,
      setTotal: setTotalCategory,
      page: categoryPage,
      apiData,
      dateFrom,
      dateTo,
      brandData,
      selectedBrand,
      selectedApi,
      setCategoryData: (e) => setCategoryData(e),
      searchParam: categoryQuery,
    });
  };

  const filtersBrand = () => {
    fetchMPBrandFilter({
      selectedSpace: selectedSpace?.value,
      page: brandPage,
      setTotal: setTotalBrand,
      apiData,
      categoryData,
      selectedCategory,
      dateFrom,
      dateTo,
      searchParam: brandQuery,
      selectedApi,
      setBrandData: (e) => setBrandData(e),
    });
  };

  useEffect(() => {
    if (!selectedApiModal?.value) {
      filtersApi();
    }
  }, [apiPage, apiQuery]);

  useEffect(() => {
    filtersCategory();
  }, [
    // apiData,
    isClear,
    dateFrom,
    dateTo,
    categoryPage,
    categoryQuery,
  ]);

  useEffect(() => {
    filtersBrand();
  }, [
    isClear,
    dateFrom,
    dateTo,
    //  categoryData,
    brandPage,
    brandQuery,
  ]);

  const fetchTable = () => {
    const abortController = new AbortController();
    if (selectedApi?.length > 0) {
      fetchTableData([], abortController);
    }

    return () => abortController.abort();
  };

  useEffect(() => {
    // Сброс номера страниц при перезагрузке таблицы
    paginatorRef.current?.reset();
    paginatorRef.current?.setTotal(0);
    fetchTable()
  }, [pageValue]);

  const fetchOnePrice = (
    apiId,
    offerId,
    newPrice
  ) => {
    let url = `https://apps0.ecomru.ru:4449/mp-products/tables/set-drr`

    const body = JSON.stringify({
      price: [{
          offer_id: offerId,
          target_drr: newPrice,
          api_id: apiId
        }]
    })

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {})
      .catch(handleRequestError);
  };

  const handleSaveOnePrice = (e) => {
    const { inputEvent, actionEvent, setStatus } = e;
    const offerId = inputEvent?.id;
    const apiId = actionEvent?.[0]?.api_id;

    let newPrice = +inputEvent?.value;

    if (newPrice || newPrice == 0) {
      setStatus('loading');
      fetchOnePrice(apiId, offerId, newPrice, setStatus);
    } else {
      setStatus('error');
    }
  };


  return (
    <div className="installation-DRR">
      {isShowTitle && <TitlePage
        title='Установка ДРР'
      />}

      <div className="installation-DRR__toolbar-top">
        <FilterContainer
          onReset={(e) => {
            setSelectedApi([]);
            setSelectedCategory([]);
            setSelectedBrand([]);
            setIsClear(!isClear);
          }}
        >
          {page && <DropDownSelector
            options_prop={apiData}
            state={selectedApi}
            setState={setSelectedApi}
            placeholder="Магазин"
            total={totalApi}
            multi
            fetchCallback={setApiPage}
            setInputChange={setApiQuery}
            onBlur={() => {
              filtersCategory();
              filtersBrand();
              fetchTable();
            }}
          />}

          <DropDownSelector
            options_prop={categoryData}
            state={selectedCategory}
            setState={setSelectedCategory}
            placeholder="Категория"
            total={totalCategory}
            multi={true}
            fetchCallback={setCategoryPage}
            setInputChange={setCategoryQuery}
            onBlur={() => {
              filtersBrand();
              fetchTable();
            }}
          />

          <DropDownSelector
            options_prop={brandData}
            state={selectedBrand}
            setState={setSelectedBrand}
            placeholder="Бренд"
            total={totalBrand}
            multi={true}
            fetchCallback={setBrandPage}
            setInputChange={setBrandQuery}
            onBlur={() => {
              filtersCategory();
              fetchTable();
            }}
          />

          <SearchComponent
            searchValue={searchValue}
            errSearch={false}
            placeholder="Поиск товара"
            errText="Неверный товар"
            setSearchValue={setSearchValue}
            fetchData={fetchTableData}
            fetchCallback={fetchSearch}
            data={searchData}
            onClearDependence={[isClear]}
          />
        </FilterContainer>
      </div>

      <Tabs
        tabs={btn_tab}
        stopRedirect={stopRedirect}
        pageValue={pageValue}
        setPageValue={setPageValue}
      />

      <TableBox
        {...tableProps}
        refContainer={refContainer}
        paginator={true}
        ref={paginatorRef}
        fetchCallback={fetchTableData}
        upload
        onInputAction={handleSaveOnePrice}
      />
    </div>
  );
};

export { InstallationDRR };
